/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseIconAsset } from '../../models/api-response-icon-asset';

export interface UpdateIconAsset$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: {
'iconAsset': string;
'file'?: Blob;
}
}

export function updateIconAsset(http: HttpClient, rootUrl: string, params: UpdateIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseIconAsset>> {
  const rb = new RequestBuilder(rootUrl, updateIconAsset.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseIconAsset>;
    })
  );
}

updateIconAsset.PATH = '/v1/api/admin-ui/icon-asset/update';
